import { createStore } from "vuex";
import axios from "axios";
// import { advisor_types_api, advisors_api, advisor_api } from "../../../config/api";

export default createStore({
    state: {
        //advisors: [],
        distance: null,
        filters: {
            hours: null,
            type: null
        },
        isInitializing: true,
        isLoading: true,
        //isSpecificAdvisor: false,
        //selectedAdvisor: null,
        //typeFilterOptions: [],
        userLocation: {},
        userSearchLocation: {}
    },
    mutations: {
        //SET_ADVISORS(state, advisors) {
        //    state.advisors = advisors;
        //},
        //SET_FILTERS(state, payload) {
        //    state.filters = payload;
        //},
        SET_INITIALIZING(state, payload) {
            state.isInitializing = payload;
        },
        //SET_IS_SPECIFIC_ADVISOR(state, payload) {
        //    state.isSpecificAdvisor = payload;
        //},
        SET_LOADING(state, isLoading) {
          state.isLoading = isLoading;
        },
        //SET_SELECTED_ADVISOR(state, advisor) {
        //    state.selectedAdvisor = advisor;
        //},
        //SET_TYPE_FILTER_OPTIONS(state, options) {
        //    state.typeFilterOptions = options;
        //},
        SET_USER_DISTANCE(state, distance) {
            state.distance = distance;
        },
        SET_USER_SEARCH_LOCATION(state, location) {
            state.userSearchLocation = location;
        },
        SET_USER_LOCATION(state, location) {
            state.userLocation = location;
        },
        //SET_USER_SEARCH_NAME(state, name) {
        //    state.userSearchName = name;
        //},
        //SET_USER_TYPE(state, payload) {
        //    state.filters.type = payload;
        //}
    },
    getters: {
        //userType(state) {
        //    return state.filters.type;
        //}
    },
    actions: {
        clearSearch({ commit }) {
            //commit("SET_ADVISORS", []);
            //commit("SET_FILTERS", {
            //    hours: null,
            //    type: null
            //});
            commit("SET_USER_SEARCH_LOCATION", {});
            //commit("SET_USER_SEARCH_NAME", null);
        },
        //updateAdvisors: async ({ commit }, payload) => {
        //    commit("SET_LOADING", true);
        //    try {
        //        let { data } = await axios.get(
        //            advisors_api.URI,
        //            {
        //                params: payload,
        //                auth: advisors_api.auth
        //            }
        //        );

        //        commit("SET_ADVISORS", data.advisors);
        //        commit("SET_LOADING", false);
        //        commit("SET_INITIALIZING", false);
        //    } catch (e) {
        //        console.log(e);
        //    }
        //},
        geolocateUser: async ({ commit }) => {
            if (navigator.geolocation) {
                commit("SET_LOADING", true);
                await navigator.geolocation.getCurrentPosition(
                    position => {
                        let payload = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        };
                        console.info("test set user location based on browser", payload.lat, payload.lng);
                        commit("SET_USER_LOCATION", payload);
                    },
                    err => {
                        console.log("User did not allow geolocation");
                        commit("SET_USER_LOCATION", {});
                        console.log(err);
                    }
                );
            }
        },
        updateDistance({ commit }, payload) {
            commit("SET_USER_DISTANCE", payload);
        },
        //updateFilters({ commit }, payload) {
        //    commit("SET_FILTERS", payload);
        //},
        updateIsInitializing({ commit }, payload) {
            commit("SET_INITIALIZING", payload);
        },
        updateUserSearchLocation({ commit }, payload) {
            commit("SET_USER_SEARCH_LOCATION", payload);
        },
        //updateUserType({ commit }, payload) {
        //    commit("SET_USER_TYPE", payload);
        //}
    }
});
